import React, { useState, useEffect } from "react";
import {
  Form,
  Row,
  Col,
  Button,
  Input,
  Spin,
  message,
  Card,
  Table,
  Tag,
  Tooltip,
  Space,
  Popconfirm,
} from "antd";
import {
  CaretRightOutlined,
  QuestionCircleFilled,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  apiGetMember,
  apiPatchMember,
  apiResetPsd,
  apiGetOrder,
  apiGetOrderDetail,
  apiGetOtp,
  apiConfirmOTP,
  apiVerifyEmail,
  apiCreateSwitchTicket,
} from "api/api";
import { useNavigate } from "react-router-dom";
import { convertTimeStamp } from "utility/functions/convertTimestamp";
import { errorHandler } from "utility/functions/errorHandler";

import { Columns, Columns_mobile } from "./columns";
import { paymentStatus, orderStatus } from "./options";
import { paymentMethodMap } from "utility/options/paymentMethod";
import { useTranslation } from "react-i18next";

import keyBy from "lodash/keyBy";
import DetailModal from "./components/DetailModal";
import ExchangeTicketModal, {
  checkAvailableTickets,
} from "./components/ExchangeTicketModal";
import { apiErrorHandler, apiSuccessHandler } from "api";
import PhoneInput from "components/PhoneInput";

const Member = () => {
  const [form] = Form.useForm();

  const { i18n, t } = useTranslation();

  const navigate = useNavigate();
  const isLogIn =
    sessionStorage._skyFilm_t && sessionStorage._skyFilm_t.length > 0;

  const [isLoading, setIsLoading] = useState(false);
  const [isValidEmailLoading, setIsValidEmailLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false); // 是否為手機版&平板，是：訂單中表格改為下拉展開顯示
  const [isCardLoading, setIsCardLoading] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [record, setRecord] = useState({});
  const [otpKey, setOtpKey] = useState("");
  const [isOtpLoading, setIsOtpLoading] = useState(false);

  // # 檢視更多
  const [isModalOpen, setIsModalOpen] = useState(false);

  // # 表單是否有變動
  const [isFormChange, setIsFormChange] = useState(false);
  // // # Email輸入欄位是否有變動
  // const [isEmailChange, setIsEmailChange] = useState(false);
  // # 是否顯示OTP輸入欄位
  const [isEmailCodeShow, setIsEmailCodeShow] = useState(false);
  const [formData, setFormData] = useState({});

  // # 換票彈窗相關
  const [isExchangeTicketModalOpen, setIsExchangeTicketModalOpen] =
    useState(false);
  const [exchangeTicketRecord, setExchangeTicketRecord] = useState(null);

  // # 取得會員資訊
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await apiGetMember();
      const { content } = res.data;
      form.setFieldsValue(content);
      setFormData(content);
    } catch (err) {
      console.log("err", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      // 與 Tailwind mobile 斷點保持一致，使用 1024px 作為斷點
      setIsMobile(window.innerWidth <= 1023);
    };

    handleResize(); // 初始化時執行一次
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isLogIn) fetchData();
    else navigate("/login");
  }, []);

  // # 取得付款資訊
  const fetchOrder = async () => {
    setIsCardLoading(true);
    try {
      const res = await apiGetOrder();
      const { content } = res.data;
      content.map((item) => {
        item.isActiveCollapse = false;
        item.details.map((dt) => {
          dt.key = dt.id; // 為了裡層的 collapse 判斷
          dt.isReturnBtnLoading = false; // 退票按鈕loading狀態
          dt.isExchangeBtnLoading = false; // 換票按鈕loading狀態
          return dt;
        });
        return item;
      });
      setOrders(content);
    } catch (err) {
      console.log("error", err);
    } finally {
      console.log("oooooo", orders);
      setIsCardLoading(false);
    }
  };

  useEffect(() => {
    fetchOrder();
  }, []);

  // # 取得票券詳情
  const fetchDetail = async (record) => {
    try {
      const res = await apiGetOrderDetail(record.id);
      console.log("rrrr", res);
      const { content } = res.data;
      setRecord(content);
      setIsModalOpen(true);
    } catch (err) {
      console.log("err", err);
    } finally {
    }
  };

  // # 儲存變更
  const updateInfo = async (data) => {
    setIsEditLoading(true);
    try {
      const res = await apiPatchMember(data);
      message.success("儲存成功");
      setIsFormChange(false);
      fetchData();
    } catch (error) {
      errorHandler(error, t);
    } finally {
      setIsEditLoading(false);
    }
  };

  const onFinish = (values) => {
    console.log("Success12:", values);
    updateInfo(values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const logOut = () => {
    sessionStorage.removeItem("_skyFilm_t");
    localStorage.removeItem("carts"); // 若有 localStorage 購物車也一併清空
    // 這裡可以用事件或 context 通知 App.js 更新 count
    window.dispatchEvent(new Event("logout")); // 觸發全域事件
    setTimeout(() => {
      navigate("/home");
      navigate(0);
    }, 500);
  };

  // # 觀察表單是否有變動
  const onValuesChange = (current, all) => {
    setIsFormChange(true);
    // setIsEmailChange(true);
  };

  // # 發送 Email 驗證信
  const handleVerify = (values) => {
    sendOtp(values);
  };

  // # 呼叫發送Email認證信API
  const sendOtp = async (values) => {
    setIsValidEmailLoading(true);
    try {
      const res = await apiGetOtp({ email: form.getFieldValue("email") });
      setOtpKey(res.data.content);
      message.success(`已發送驗證碼至${form.getFieldValue("email")}`);
      setIsEmailCodeShow(true);
    } catch (error) {
      errorHandler(error, t);
    } finally {
      setIsValidEmailLoading(false);
    }
  };

  // # 驗證Email OTP
  const handleEmailOTP = async (otp) => {
    setIsOtpLoading(true);
    try {
      const res = await apiConfirmOTP({
        otp,
        key: otpKey,
      });
      setTimeout(() => {
        verifyEmail(res.data.content);
      }, 5000);
    } catch (error) {
      errorHandler(error, t);
    }
  };

  // # 實際驗證email
  const verifyEmail = async (token) => {
    try {
      const res = await apiVerifyEmail(token);
      setIsEmailCodeShow(false); //#關閉輸入OTP卡片
      message.success("Email認證成功，請使用新信箱重新登入", 4);
      sessionStorage.removeItem("_skyFilm_t");
      setTimeout(() => {
        navigate("/login");
      }, 4500);
    } catch (error) {
      errorHandler(error, t);
    } finally {
      setIsOtpLoading(false);
      fetchData();
    }
  };

  // # 重新設定密碼，發送認證碼信件
  const resetPsd = async () => {
    try {
      const res = await apiResetPsd();
      const { content } = res.data;
      message.success("已經發送驗證碼至您的信箱");
      sessionStorage.k = content;
      setTimeout(() => {
        navigate("/confirm-otp");
      }, 1500);
    } catch (err) {
      console.log("err", err);
    }
  };

  // # 關閉彈窗
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // # 申請退票
  const handleReturnTicket = async (record) => {
    // 更新特定記錄的 loading 狀態
    setOrders((prevOrders) =>
      prevOrders.map((order) => ({
        ...order,
        details: order.details.map((detail) =>
          detail.id === record.id
            ? { ...detail, isReturnBtnLoading: true }
            : detail,
        ),
      })),
    );

    try {
      // const res = await api退票({id: record.id});
      setTimeout(() => {
        alert("申請退票！");
        // 重置退票按鈕loading狀態，而不是重新 fetchOrder
        setOrders((prevOrders) =>
          prevOrders.map((order) => ({
            ...order,
            details: order.details.map((detail) =>
              detail.id === record.id
                ? { ...detail, isReturnBtnLoading: false }
                : detail,
            ),
          })),
        );
      }, 3000);
    } catch (error) {
      apiErrorHandler(error.re, t);
      // 如果發生錯誤，也要重置 loading 狀態
      setOrders((prevOrders) =>
        prevOrders.map((order) => ({
          ...order,
          details: order.details.map((detail) =>
            detail.id === record.id
              ? { ...detail, isReturnBtnLoading: false }
              : detail,
          ),
        })),
      );
    }
  };

  // # 申請換票
  const handleExchangeTicket = async (record) => {
    // 先檢查是否有可換票場次
    const hasAvailableTickets = await checkAvailableTickets(record.id);

    // 只有在有可換票場次時才開啟彈窗
    if (hasAvailableTickets) {
      setExchangeTicketRecord(record);
      setIsExchangeTicketModalOpen(true);
    }
    // 如果沒有可換票場次，checkAvailableTickets 函數已經會顯示警告訊息
  };

  const handleExchangeTicketOk = async (data) => {
    console.log("換票數據:", data);
    const { selectedSession, originalRecord } = data;
    try {
      const res = await apiCreateSwitchTicket(
        { targetId: selectedSession },
        originalRecord?.id,
      );
      message.success(
        `正在為票券 ${originalRecord.title} 申請換到場次 ${selectedSession}`,
      );
    } catch (error) {
      message.error("換票失敗，請稍後再試");
    }

    // 關閉彈窗
    setIsExchangeTicketModalOpen(false);
    setExchangeTicketRecord(null);
  };

  // # 關閉換票彈窗
  const handleExchangeTicketCancel = () => {
    setIsExchangeTicketModalOpen(false);
    setExchangeTicketRecord(null);
  };

  return (
    <div className="w-full px-4 desktop:px-56 bg-white py-20">
      <Spin spinning={isLoading} size="large" fullscreen />
      <Row className="mb-20">
        <Col
          sm={{ span: 18 }}
          xs={{ span: 12 }}
          className="text-black text-left"
        >
          <h3 className="m-0">Hello {formData?.name}</h3>
        </Col>
        <Col
          sm={{ span: 6 }}
          xs={{ span: 12 }}
          className="text-black text-right"
        >
          {isLogIn && (
            <Button className="bg-black text-white px-2" onClick={logOut}>
              登出Log out
            </Button>
          )}
        </Col>
      </Row>

      {/* 基本資料 */}
      <Row>
        <Col span={20}>
          <h4 className="m-0 text-left text-black">基本資料 Information</h4>
        </Col>
        {/* <Col span={4} className="text-right">
          <Button className="bg-SKF-G-001 ">Save</Button>
        </Col> */}
      </Row>

      <Form
        name="member"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        form={form}
        layout="vertical"
        className="relative"
        initialValues={formData}
        onValuesChange={onValuesChange}
      >
        <Row gutter={16}>
          <Col sm={{ span: 24 }} xs={{ span: 24 }} className="mt-6">
            <Form.Item label="Name" name="name">
              <Input placeholder="名字" className="p-2" />
            </Form.Item>
          </Col>
          {/* <Col sm={{ span: 12 }} xs={{ span: 24 }}>
            <Form.Item label="Last Name" name="last_name">
              <Input placeholder="姓氏" className="p-2" />
            </Form.Item>
          </Col> */}
          <Col span={24} className="mb-5">
            <Form.Item
              label="Email"
              name="email"
              tooltip="若修改，登入將使用更改後的Email"
              className="mb-1"
            >
              <Input placeholder="Email" className="p-2" />
            </Form.Item>
            {!formData.emailConfirmed && (
              <Button
                type="primary"
                className="float-left mt-2"
                loading={isValidEmailLoading}
                onClick={handleVerify}
              >
                驗證Email
              </Button>
            )}
          </Col>
          {isEmailCodeShow && (
            <Card className="w-full text-left bg-SKF-G-000 rounded-lg mb-5 desktop:[&_.ant-otp]:w-1/4 tablet:[&_.ant-otp]:w-1/2 mobile:[&_.ant-otp]:w-full  shadow-[0px_0px_10px_0px_rgba(0,0,0,0.3)] tablet:[&_.ant-otp-input]:py-3  mobile:[&_.ant-otp-input]:py-3">
              <p className="mb-3 text-base font-semibold">請輸入驗證碼：</p>
              <Card
                loading={isOtpLoading}
                className="[&_.ant-card-body]:p-0 border-none bg-SKF-G-000"
              >
                <Input.OTP
                  variant="filled"
                  type="number"
                  onChange={handleEmailOTP}
                ></Input.OTP>
              </Card>
            </Card>
          )}
          <Col span={24}>
            <Form.Item label="Mobile Phone" name="phone" className="m-0">
              <PhoneInput
                size="large"
                className="p-0 [&_.ant-input]:p-2"
                placeholder="電話"
              />
            </Form.Item>
          </Col>
          <Col span={24} className="text-left absolute top-[-1rem] right-0">
            <Form.Item>
              <Button
                htmlType="submit"
                type="primary"
                loading={isEditLoading}
                disabled={!isFormChange}
              >
                儲存Save
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <div className="text-left">
          <Button
            type="link"
            className="p-0 text-SKF-Blue-001"
            onClick={resetPsd}
          >
            重新設定密碼 Reset your password
          </Button>
        </div>

        <div className="mt-8">
          <h4 className="m-0 text-left text-black">消費紀錄 Information</h4>
          <p className="text-SKF-Blue-001 text-base text-left my-2 mb-5">
            <a href="mailto:support@rftexp.com">
              票務問題請聯繫：support@rftexp.com
            </a>
          </p>

          {orders &&
            orders.map((order) => {
              return (
                <Card
                  title={
                    <Space className="text-white w-full [&_.ant-space-item]:grow">
                      <CaretRightOutlined
                        onClick={() => {
                          setOrders(
                            [...orders].map((object) => {
                              if (object.id === order.id) {
                                return {
                                  ...object,
                                  isActiveCollapse: !order.isActiveCollapse,
                                };
                              } else return object;
                            }),
                          );
                        }}
                        rotate={order.isActiveCollapse ? 90 : 0}
                        className="mr-5"
                      />

                      <p className="text-center text-balance">
                        {/* 活動名稱 */}
                        {order?.title}
                      </p>
                      <p className="font-semibold text-right">
                        NT＄{order?.price}
                      </p>
                    </Space>
                  }
                  loading={isCardLoading}
                  className="my-2 text-left [&_.ant-card-head]:text-black [&_.ant-card-head]:bg-black mobile:[&_.ant-card-head]:px-4"
                >
                  <Row>
                    <Col span={24} className="text-left">
                      <p>
                        {/* 可以退票 */}
                        {order.enableSwitchPolicy && (
                          <Tag color="#1677FF">#可換票</Tag>
                        )}

                        {/* 可以換票 */}
                        {order.enableRefundPolicy && (
                          <Tag color="#EF4444">#可退票</Tag>
                        )}
                      </p>
                      <p className="text-SKF-G-002">
                        訂單狀態：
                        <span className="font-bold">
                          {
                            orderStatus.find(
                              (item) => item.value === order?.status,
                            )?.label
                          }
                          {order?.status === 1 && (
                            <span>(請稍候刷新頁面）)</span>
                          )}
                        </span>
                        {order?.status === 64 && (
                          <Tooltip
                            title="超過一小時未完成付款，自動取消"
                            className="ml-1"
                            color="#9D9D9D"
                          >
                            <QuestionCircleFilled />
                          </Tooltip>
                        )}
                      </p>
                      {order?.status === 32 && (
                        <p className="text-SKF-G-002">
                          支付訊息：
                          <span className="font-bold">
                            {order?.message || "-"}
                          </span>
                        </p>
                      )}
                      <p className="text-SKF-G-002">
                        消費時間：
                        {convertTimeStamp(order?.creationDate)}
                      </p>
                      <p className="text-SKF-G-002">訂單編號：{order?.id}</p>
                      <p className="text-SKF-G-002">
                        付款方式：
                        {paymentMethodMap[order?.paymentMethod]?.name || "-"}
                      </p>
                      <p className="text-SKF-G-002">
                        票券數量：
                        {order?.details?.length}
                      </p>
                    </Col>
                  </Row>
                  {order?.isActiveCollapse && (
                    <Row className="mt-5">
                      <Col span={24}>
                        <Card className="[&_.ant-card-body]:p-0">
                          <Table
                            className="w-full"
                            rowKey="id"
                            size="small"
                            columns={
                              isMobile
                                ? Columns_mobile({
                                    fetchDetail,
                                    order,
                                    handleReturnTicket,
                                    handleExchangeTicket,
                                  })
                                : Columns({
                                    fetchDetail,
                                    handleReturnTicket,
                                    order,
                                    handleExchangeTicket,
                                  })
                            }
                            dataSource={order?.details}
                            pagination={false}
                            expandable={
                              isMobile
                                ? {
                                    expandedRowRender: (record) => (
                                      <>
                                        <p className="m-0">
                                          票券名稱：{record.title}
                                        </p>
                                        <p className="m-0">
                                          價格：{record.price}
                                        </p>
                                        <p className="m-0">
                                          參加者：{record.name}
                                        </p>
                                        <p className="m-0">
                                          Email：{record.email}
                                        </p>
                                      </>
                                    ),
                                    rowExpandable: (record) =>
                                      record.name !== "Not Expandable",
                                  }
                                : null
                            }
                          ></Table>
                        </Card>
                      </Col>
                    </Row>
                  )}
                </Card>
              );
            })}
        </div>
      </Form>
      <DetailModal
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
        record={record}
      />
      <ExchangeTicketModal
        isModalOpen={isExchangeTicketModalOpen}
        handleCancel={handleExchangeTicketCancel}
        handleExchangeTicketOk={handleExchangeTicketOk}
        record={exchangeTicketRecord}
      />
    </div>
  );
};

export default Member;
